import React, { Fragment } from 'react';
import styles from './index.css';
import { LoginIdContext } from '../../utils/loginId';
import { rel } from '../../utils/rel';
import FloorList from './floorList';
import BottomBar from './bottomBar';
import renderEmoji from '../../utils/renderEmoji';
class CommentBox extends React.PureComponent {
    render() {
        const { content: { basicParentList, moreParentList, 
        // user_url,
        user_id, uname, ip_from, contents, comment_id, year, date, time, cmtVoteUrl, docUrl, uptimes, isTemp, }, replyId, setReplyId, allow_comment, curPage, } = this.props;
        const floorList = {
            basicParentList: basicParentList || [],
            moreParentList: moreParentList || [],
        };
        const bottomBarData = {
            comment_id,
            year,
            date,
            time,
            cmtVoteUrl,
            docUrl,
            uptimes,
        };
        return (React.createElement("div", { className: styles.comment_box },
            isTemp ? (React.createElement(LoginIdContext.Consumer, null, (value) => (React.createElement("p", { className: styles.username },
                React.createElement("a", { href: `//gentie.ifeng.com/myComments?guid=${value.user_id}`, target: "_blank", rel: rel }, value.userInfo && value.userInfo.userName))))) : (React.createElement(Fragment, null, user_id ? (React.createElement("p", { className: styles.username },
                React.createElement("a", { href: `//gentie.ifeng.com/myComments?guid=${user_id}`, target: "_blank", rel: rel }, uname),
                React.createElement("span", null,
                    " [",
                    ip_from,
                    "\u7F51\u53CB]"))) : (React.createElement("p", { className: styles.username },
                uname,
                React.createElement("span", null,
                    " [",
                    ip_from,
                    "\u7F51\u53CB]"))))),
            basicParentList && basicParentList.length > 0 ? (React.createElement(FloorList, { content: floorList, cmtVoteUrl: cmtVoteUrl, replyId: replyId, setReplyId: setReplyId, allow_comment: allow_comment, curPage: curPage })) : (''),
            isTemp ? (React.createElement("p", { className: styles.content_txt, dangerouslySetInnerHTML: { __html: renderEmoji(contents || '') } })) : (React.createElement("p", { className: styles.content_txt, dangerouslySetInnerHTML: { __html: contents || '' } })),
            React.createElement(LoginIdContext.Consumer, null, (value) => (React.createElement(BottomBar, { loginId: value.loginId, config: value.config, content: bottomBarData, replyId: replyId, setReplyId: setReplyId, handleJubShow: value.handleJubShow, jubCommentIdArr: value.jubCommentIdArr, curPage: curPage })))));
    }
}
export default CommentBox;
